module.exports = __webpack_public_path__ + "static/img/SpeedProp.cd5f943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/SpeedProp.png
// module id = XyG+
// module chunks = 0